import React, { useState, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import {
  Modal,
  ModalBody,
  ModalHeader,
  Button,
  FormGroup,
  Label,
  Container,
  Spinner,
} from "reactstrap";
import * as types from "../../types";
import { msalSettingsServices } from "../../services";
import messages from "../../util/messages";
import { dispatch } from "../../actions/util";

const MSALSettingModal = ({
  isOpenMSALSettingModal,
  closeMSALSettingModal,
  isFetching,
}) => {
  const [settings, setSettings] = useState({
    clientID: "",
    tenantID: "",
    redirectUri: "",
    groups: "",
  });

  useEffect(() => {
    if (isOpenMSALSettingModal) {
      getMSALSettings();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpenMSALSettingModal]);

  const getMSALSettings = () => {
    dispatch({ type: types.FETCHING });
    msalSettingsServices()
      .getMSALSettings()
      .then((res) => {
        const setting = {
          clientID: res.data && res.data.clientID ? res.data.clientID : "",
          tenantID: res.data && res.data.tenantID ? res.data.tenantID : "",
          redirectUri:
            res.data && res.data.redirectUri ? res.data.redirectUri : "",
          groups: res.data && res.data.groups ? res.data.groups : ""
        };
        setSettings(setting);
        dispatch({ type: types.FETCHING_END });
      })
      .catch(() => {
        setSettings({ clientID: "", tenantID: "", redirectUri: "" });
        dispatch({ type: types.FETCHING_END });
      });
  };

  const onCloseModal = () => closeMSALSettingModal();
  const updateMSALSettings = (params) => {
    dispatch({ type: types.FETCHING });
    msalSettingsServices()
      .updateMSALSettings({
        clientID: params.clientID,
        tenantID: params.tenantID,
        redirectUri: params.redirectUri,
        groups: params.groups
      })
      .then(() => {
        onCloseModal();
        dispatch({ type: types.FETCHING_END });
        dispatch({
          type: types.ADD_ALERT_NOTIFICATION,
          message: messages.UPDATE_MSAL_SETTINGS_SUCCESS,
          color: "info",
        });
      })
      .catch((err) => {
        dispatch({
          type: types.ADD_ALERT_NOTIFICATION,
          message:
            err.response && err.response.data && err.response.data.message
              ? err.response.data.message
              : messages.UPDATE_MSAL_SETTINGS_FAILURE,
          color: "danger",
        });
        dispatch({ type: types.FETCHING_END });
      });
  };

  return (
    <Modal
      className="md-modal"
      isOpen={isOpenMSALSettingModal}
      toggle={onCloseModal}
    >
      <ModalHeader toggle={onCloseModal}>MSAL Settings</ModalHeader>
      <ModalBody>
        <Container>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                updateMSALSettings(settings);
              }}
            >
              <FormGroup>
                <Label for="clientID">Client ID</Label>
                <input
                  id="clientID"
                  name="clientID"
                  className="form-control"
                  value={settings.clientID}
                  onChange={(e) =>
                    setSettings({ ...settings, clientID: e.target.value })
                  }
                  placeholder="Enter Azure AD Application (Client) ID"
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label for="tenantID">Tenant ID</Label>
                <input
                  id="tenantID"
                  name="tenantID"
                  className="form-control"
                  value={settings.tenantID}
                  onChange={(e) =>
                    setSettings({ ...settings, tenantID: e.target.value })
                  }
                  placeholder="Enter Azure AD Directory (Tenant) ID"
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label for="redirectUri">Redirect URI</Label>
                <input
                  id="redirectUri"
                  name="redirectUri"
                  className="form-control"
                  value={settings.redirectUri}
                  onChange={(e) =>
                    setSettings({ ...settings, redirectUri: e.target.value })
                  }
                  placeholder="Enter Redirect URI"
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label for="groups">Allowed Group IDs</Label>
                <input
                  id="groups"
                  name="groups"
                  className="form-control"
                  value={settings.groups}
                  onChange={(e) =>
                    setSettings({ ...settings, groups: e.target.value })
                  }
                  placeholder="Enter allowed Azure AD group IDs (comma-separated)"
                  required={false}
                />
                <small className="form-text text-muted">Comma-separated Azure AD group IDs. Only users in these groups can log in.</small>
              </FormGroup>
              <div
                className="d-flex align-items-center justify-content-end"
                style={{
                  marginTop: "30px",
                  borderTop: "1px solid #797979",
                  paddingTop: "15px",
                }}
              >
                {isFetching ? (
                  <Spinner size="sm">Loading...</Spinner>
                ) : (
                  <Fragment>
                    <Button type="submit" outline disabled={isFetching}>
                      Save
                    </Button>
                    <span className="mx-2">or</span>
                    <Button
                      outline
                      color="danger"
                      onClick={onCloseModal}
                      disabled={isFetching}
                    >
                      Cancel
                    </Button>
                  </Fragment>
                )}
              </div>
            </form>
        </Container>
      </ModalBody>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  isOpenMSALSettingModal: state.isOpenMSALSettingModal,
  isFetching: state.isFetching,
});

const mapDispatchToProps = (dispatch) => {
  return {
    closeMSALSettingModal: () => dispatch({ type: "CLOSE_MSAL_SETTING_MODAL" }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MSALSettingModal);
